var SCROLL_INSURANCE = 500;
var lastScrollTopForDown = 0;
var lastScrollTopForUp = 0;
var useInfiniteScroll = function (scrollInsurance) {
    if (scrollInsurance === void 0) { scrollInsurance = SCROLL_INSURANCE; }
    var onInfiniteScrollDown = function (event, callback, conditions) {
        var _a = event.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, offsetHeight = _a.offsetHeight;
        if (scrollHeight - offsetHeight - scrollTop < scrollInsurance) {
            // scrolling last ${scrollInsurance} pixels
            if (lastScrollTopForDown < scrollTop) {
                // scrolling down
                if (conditions.every(function (condition) { return condition; })) {
                    // if all conditions true
                    callback();
                }
            }
        }
        lastScrollTopForDown = scrollTop;
    };
    var onInfiniteScrollUp = function (event, callback, conditions) {
        var _a = event.target, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        if (scrollTop * 3 < scrollHeight) {
            // scrolling first 30%
            if (lastScrollTopForUp > scrollTop) {
                // scrolling up
                if (conditions.every(function (condition) { return condition; })) {
                    // if all conditions true
                    callback();
                }
            }
        }
        lastScrollTopForUp = scrollTop;
    };
    return {
        onInfiniteScrollUp: onInfiniteScrollUp,
        onInfiniteScrollDown: onInfiniteScrollDown,
    };
};

export { useInfiniteScroll };
